import { render, staticRenderFns } from "./TextareaField.vue?vue&type=template&id=0342ea32&scoped=true"
import script from "./TextareaField.vue?vue&type=script&setup=true&lang=js"
export * from "./TextareaField.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TextareaField.vue?vue&type=style&index=0&id=0342ea32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0342ea32",
  null
  
)

export default component.exports